export default "__VITE_ASSET__BoC6DJWv__"